export default __webpack_public_path__ + "images/c051641807b2445e885e969c68816296.svg";